export const isValidPhoneNumber = (phoneNumber) => {
  if (!phoneNumber || !phoneNumber.trim()) return false;

  const value = phoneNumber.trim();
  if (!/^\+?[0-9() .-]+$/.test(value) || (value.includes('+') && !value.startsWith('+'))) {
    return false;
  }

  const digitCount = value.replace(/\D/g, '').length;
  return digitCount >= 7 && digitCount <= 15;
};

export const PHONE_NUMBER_ERROR = 'Enter a valid phone number.';
